"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import '../../../OverlayTrigger/components/MenuTrigger/MenuTrigger.mjs';
import { OverlayTrigger } from '../../../OverlayTrigger/OverlayTrigger.mjs';
import '../../../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../../../lib/propsContext/PropsContextProvider.mjs';
import locales from '../../../../../../_virtual/_.locale.json@df0c8534e2e4f7c6c3d4365218df7347.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import { IconInfo } from '../../../Icon/components/icons/IconInfo.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';

const ContextualHelpTrigger = flowComponent(
  "ContextualHelpTrigger",
  (props) => {
    const { children, ...triggerProps } = props;
    const stringFormatter = useLocalizedStringFormatter(locales);
    const propsContext = {
      Button: {
        "aria-label": stringFormatter.format(
          "contextualHelpButton.moreInformation"
        ),
        children: /* @__PURE__ */ jsx(IconInfo, {}),
        size: "s",
        variant: "plain",
        ariaSlot: null
      }
    };
    return /* @__PURE__ */ jsx(
      OverlayTrigger,
      {
        overlayType: "ContextualHelp",
        ...triggerProps,
        component: Aria.DialogTrigger,
        children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children })
      }
    );
  }
);

export { ContextualHelpTrigger, ContextualHelpTrigger as default };
//# sourceMappingURL=ContextualHelpTrigger.mjs.map
